import { render, staticRenderFns } from "./returnExcOpt.vue?vue&type=template&id=266f65d6"
import script from "./returnExcOpt.vue?vue&type=script&lang=js"
export * from "./returnExcOpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports